import { render, staticRenderFns } from "./ChartbrewReport.vue?vue&type=template&id=5a7caca0&"
import script from "./ChartbrewReport.vue?vue&type=script&lang=js&"
export * from "./ChartbrewReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports